module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    key: _vm.updateIndex,
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.divider) ? _c('v-divider', {
      key: i,
      class: item.className
    }) : _vm._e(), _vm._v(" "), (item.items && (!item.roles || _vm.$auth.hasRole(item.roles))) ? [_c('v-subheader', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(subItem) {
      return _c('navigation-item', {
        key: subItem.title,
        attrs: {
          "item": subItem
        }
      })
    })] : _vm._e(), _vm._v(" "), (!item.divider && !item.items) ? _c('navigation-item', {
      key: i,
      attrs: {
        "item": item
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6df0a897","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 1080
// module chunks = 1